export default ({ COLORS }) => ({
  container: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: '1px solid #ececec',
    padding: '16px 0'
  },
  title: {
    margin: '0 0 5px'
  },
  address: {
    fontSize: '10px',
    lineHeight: '12px',
    margin: '0'
  },
  selected: {
    background: COLORS.BLUE.NORMAL,
    borderColor: COLORS.BLUE.NORMAL,
    color: '#fff'
  }
})
